<template>
  <div>
    <h1>{{ $t("settings.users.userNew") }}</h1>

    <div class="mt-3 elevation-12 grey lighten-4">
      <v-tabs centered icons-and-text>
        <v-tab key="general">
          {{ $t("settings.users.personalData") }}
          <v-icon>account_box</v-icon>
        </v-tab>
        <v-tab-item key="general">
          <v-card>
            <v-card-text>
              <v-form lazy-validation ref="form" v-model="formValid">
                <v-radio-group :mandatory="false" row v-model="users.sex">
                  <v-radio :label="$t('global.mr')" :value="1" />
                  <v-radio :label="$t('global.ms')" :value="2" />
                  <v-radio :label="$t('global.notSet')" :value="0" />
                </v-radio-group>
                <v-text-field :label="$t('settings.users.fields.name.name') + '*'" :rules="users.nameRules" v-model="users.name" />
                <v-text-field :label="$t('settings.users.fields.surname.name') + '*'" :rules="users.surnameRules" v-model="users.surname" />
                <v-text-field :label="$t('settings.users.fields.login.name') + '*'" :rules="loginValidator" v-model="users.login" />
                <v-text-field :label="$t('settings.users.fields.email.name') + '*'" :rules="users.emailRules" v-model="users.email" />
                <v-checkbox :label="$t('settings.users.passwordByEmail')" v-model="passwordByMail" />
                <v-text-field
                  :label="$t('settings.users.fields.password.name') + '*'"
                  :placeholder="users.id != null ? $t('settings.users.fields.password.noChange') : ''"
                  :rules="passwordRules"
                  password
                  :disabled="users.password_by_mail"
                  type="password"
                  ref="passwordInput"
                  v-model="users.password"
                />
                <v-text-field
                  :label="$t('settings.users.fields.repeatPassword.name') + '*'"
                  :placeholder="users.id != null ? $t('settings.users.fields.repeatPassword.noChange') : ''"
                  :rules="users.repeatPasswordRules"
                  :disabled="users.password_by_mail"
                  password
                  type="password"
                  ref="passwordInputRepeat"
                  v-model="users.repeatPassword"
                />
                <template
                  v-if="
                    $store.getters['userProperties'].system_settings.is_module_travel_service_enabled === 2 ||
                      $store.getters['userProperties'].system_settings.is_module_delegation_enabled === 2
                  "
                >
                  <v-text-field :label="$t('settings.users.fields.integrationIdentifier.name')" v-model="users.integration_identifier" />
                  <v-autocomplete :items="availableSuperiors" :label="$t('settings.users.fields.superiorUser.name')" v-model="users.superior_user_id" />
                  <v-autocomplete
                    :items="availableOrganisationStructures"
                    :label="$t('settings.users.fields.organizationStructure.name')"
                    v-model="users.organization_structure_id"
                  />
                  <v-autocomplete
                    :items="availablePrivateVehicles"
                    :label="$t('settings.users.fields.privateVehicle.name')"
                    v-model="users.vehicle_private_id"
                  />
                  <v-autocomplete
                    :items="availableDefaultVehicles"
                    :label="$t('settings.users.fields.defaultVehicle.name')"
                    v-model="users.vehicle_default_id"
                  />
                  <v-text-field :label="$t('settings.users.fields.bankName.name')" v-model="users.bank_name" />
                  <v-text-field :label="$t('settings.users.fields.bankAccount.name')" v-model="users.bank_account_number" />
                  <location-ajax-select :label="$t('global.homeLocation')" :placeholder="users.home_address_name" :select-model.sync="users.home_address_id" />
                  <location-ajax-select :label="$t('global.workLocation')" :placeholder="users.work_address_name" :select-model.sync="users.work_address_id" />
                  <v-autocomplete
                    :clearable="true"
                    :items="availableDelegationGroups"
                    :label="$t('settings.users.fields.delegationRateGroup.name')"
                    v-model="users.group_id"
                  />
                  <v-select :items="languageChooser" :label="$t('settings.users.fields.language.name')" v-model="users.language" />
                  <v-checkbox
                    :label="$t('settings.users.basicData.fields.isNotifyNewTravelServiceResponse.name')"
                    v-model="users.is_notify_new_travel_service_response"
                  />
                </template>
              </v-form>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
      <v-card>
        <v-card-actions>
          <v-spacer />
          <v-btn @click.native="cancel()" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
          <v-btn :disabled="!formValid || $store.getters['Ajax/loading']" @click="save()" color="blue darken-1" text>{{ $t("global.add") }} </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import user from "../../../models/user";
import vehicleTypes from "../../../staticData/VehicleTypes";
import LocationAjaxSelect from "../../CustomInputComponents/LocationAjaxSelect.vue";
import wnbAddresses from "../../../wnbAddresses";

export default {
  name: "NewUsersForm",
  components: { LocationAjaxSelect },
  data: () => ({
    users: new user(),
    allSuperiorUsers: [],
    allOrganisationStructures: [],
    allPrivateVehicles: [],
    formValid: true,
    allVehicles: [],
    allDelegationGroups: [],
    allAuthItems: [],
    search: null,
    usedLogins: []
  }),
  created() {
    if (typeof this.$route.params.id !== "undefined") {
      this.users.load(this.$route.params.id);
    }
    this.axios.get("settings/user/get-logins").then(resp => {
      this.usedLogins = resp.data;
    });
    this.axios.get("settings/user/available-superior-users").then(resp => {
      this.allSuperiorUsers = resp.data;
    });
    this.axios.get("settings/user/available-organisation-structures").then(resp => {
      this.allOrganisationStructures = resp.data;
    });
    this.axios.get("settings/user/available-private-vehicles").then(resp => {
      this.allPrivateVehicles = resp.data;
    });
    this.axios.get("settings/user/available-default-vehicles").then(resp => {
      this.allVehicles = resp.data;
    });
    this.axios.get("settings/user/available-delegation-groups").then(resp => {
      this.allDelegationGroups = resp.data;
    });
  },
  computed: {
    loginValidator() {
      const temp = this;
      return [
        v => (v != null && v.length > 0) || temp.$t("user.validation.loginIsRequired"),
        v => v.length >= 6 || temp.$t("user.validation.loginMustBeValid"),
        v => !this.usedLogins.includes(v) || temp.$t("settings.users.loginAlreadyExist")
      ];
    },
    passwordRules() {
      if (this.passwordByMail) {
        return true;
      }
      return this.users.passwordRules;
    },
    passwordByMail: {
      get() {
        return this.users.password_by_mail;
      },
      set(value) {
        this.users.password_by_mail = value;
        if (value === true) {
          this.users.password = "";
          this.users.repeatPassword = "";
        }
        this.$refs.passwordInput.validate();
        this.$refs.passwordInputRepeat.validate();
      }
    },
    languageChooser() {
      let result = [];
      result.push({
        text: this.$t("settings.users.fields.language.polish"),
        value: "pl-PL"
      });
      result.push({
        text: this.$t("settings.users.fields.language.english"),
        value: "en-US"
      });
      return result;
    },
    vehicleTypes: vehicleTypes,
    availableSuperiors() {
      const array = [];
      for (let superiorUser of this.allSuperiorUsers) {
        if (superiorUser.id !== this.users.id) {
          array.push({
            value: superiorUser.id,
            text: superiorUser.name + " " + superiorUser.surname + " (" + superiorUser.login + ")"
          });
        }
      }
      return array;
    },
    availableOrganisationStructures() {
      const array = [];
      for (let organisation of this.allOrganisationStructures) {
        array.push({
          value: organisation.id,
          text: organisation.name + " " + organisation.description
        });
      }
      return array;
    },
    availablePrivateVehicles() {
      const array = [];
      for (let vehicle of this.allPrivateVehicles) {
        array.push({
          value: vehicle.id,
          text:
            this.vehicleTypes.filter(vehicleType => vehicleType.id === vehicle.type).pop().name +
            " " +
            vehicle.model +
            " " +
            vehicle.engine_capacity +
            " cm3 (" +
            vehicle.plates +
            ")"
        });
      }
      return array;
    },
    availableDefaultVehicles() {
      const array = [];
      for (let vehicle of this.allVehicles) {
        array.push({
          value: vehicle.id,
          text:
            this.vehicleTypes.filter(vehicleType => vehicleType.id === vehicle.type).pop().name +
            " " +
            vehicle.model +
            " " +
            vehicle.engine_capacity +
            " cm3 (" +
            vehicle.plates +
            ")"
        });
      }
      return array;
    },
    availableDelegationGroups() {
      const array = [];
      for (let delegationGroup of this.allDelegationGroups) {
        array.push({
          value: delegationGroup.id,
          text: delegationGroup.name + " " + delegationGroup.description
        });
      }
      return array;
    }
  },
  methods: {
    wnbAddresses: wnbAddresses,
    save() {
      if (this.$refs.form.validate()) {
        this.axios.post("settings/user/save-new-user", this.users).then(resp => {
          this.$store.dispatch("snackbarPush", {
            text: this.$t("global.saved"),
            position: "down"
          });
          this.$router.push({
            path: "/settings/users/edit/" + resp.data.userId + "/cost-centre"
          });
        });
      }
    },
    cancel() {
      this.$router.push({ path: "/settings/users" });
    },
    redirectToWnb() {
      window.location.href = this.wnbAddresses("USER") + "/" + this.users.email;
    }
  }
};
</script>

<style scoped></style>
